import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = () => {
  const [loading, setLoading] = useState(false); // ✅ use this instead
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    if (!navigator.geolocation) {
      toast.error("Geolocation not supported.");
      return;
    }

    setLoading(true); // ✅ start loading

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;

          const payload = {
            ...data,
            subject: 'aaaaaaaa',
            location: [latitude, longitude],
          };
          const baseUrl = process.env.REACT_APP_BASE_URL;

          const response = await axios.post(
            `${baseUrl}/contactus`,
            payload,
            {
              headers: { 'Content-Type': 'application/json' },
            }
          );

          toast.success(response?.data?.message || "Message sent successfully", {
            position: "top-right",
          });
          reset(); // ✅ clear the form
        } catch (error) {
          console.error("Error:", error);
          toast.error("Failed to send message.");
        } finally {
          setLoading(false); // ✅ end loading
        }
      },
      (error) => {
        console.error("Geolocation error:", error);
        toast.error("Location access denied.");
        setLoading(false); // ✅ end loading even on error
      }
    );
  };

  return (
    <div className="container-xxl py-5">
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="container">
        <div className="text-center mx-auto mb-5" style={{ maxWidth: 500 }}>
          <p className="text-primary text-uppercase mb-2">Contact Us</p>
          <h1 className="display-6">If You Have Any Query, Please Contact Us</h1>
        </div>
        <div className="row g-0 justify-content-center">
          <div className="col-lg-8">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                      id="name"
                      placeholder="Your Name"
                      {...register('name', { required: 'Name is required' })}
                    />
                    <label htmlFor="name">Your Name</label>
                    {errors.name && <div className="text-danger mt-1">{errors.name.message}</div>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="tel"
                      className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                      id="mobile"
                      placeholder="Mobile Number"
                      {...register('mobile', {
                        required: 'Mobile number is required',
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: 'Enter valid 10-digit number',
                        },
                      })}
                    />
                    <label htmlFor="mobile">Mobile Number</label>
                    {errors.mobile && <div className="text-danger mt-1">{errors.mobile.message}</div>}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your Email"
                      {...register('email')}
                    />
                    <label htmlFor="email">Your Email</label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Leave a message here"
                      id="message"
                      style={{ height: 200 }}
                      {...register('message')}
                    />
                    <label htmlFor="message">Message</label>
                  </div>
                </div>
                <div className="col-12 text-center">
                  <button
                    className="btn btn-primary py-3 px-5"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? 'Submitting...' : 'Send Message'}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
